import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { formatQueryParams } from "helpers/format";
import commentApi from "api/commentApi";

export const getCommentList = createAsyncThunk(
  "Comment",
  async (params: any = {}) => {
    try {
      const response = await commentApi.getComments(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getCommentDetail =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await commentApi.getCommentDetail(id)
    return response;
  }catch (error) {
    return error;
  }
};

export const postComment = async (data: any = {}) => {
  try{
    const response = await commentApi.postComment(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putComment = async (id: string | number , data: any = {}) => {
  try{
    const response = await commentApi.putComment(id, data);
    return response;
  }catch (error) {
    return error;
  }
};